export enum ProviderNoteStateEnum {
  open = 1,
  closed = 2
}
